import { APPCOOKIE } from "utils/defaults";
import { useAuth } from "components/custom/authprovider";
import { APPADMINCOOKIE } from "utils/defaults";
import logoutRedirect from "utils/logoutRedirect";
import { APPPACKAGECOOKIE } from "utils/defaults";

function Logout()  { 
  const {setWT, setIsAuthenticated}  = useAuth();

  localStorage.clear(APPCOOKIE);
  localStorage.clear(APPADMINCOOKIE);
  // sessionStorage.clear(APPPACKAGECOOKIE);
  setIsAuthenticated(false);
  setWT(null);

  return logoutRedirect();
}

export default Logout;